/* Table of contents for long policy pages.
   Shopify RTE emits no heading ids, so we add them, then build the list.
   Progressive enhancement: the nav ships hidden and only reveals if there
   are enough headings to be worth the space. */
(function () {
  var MIN_HEADINGS = 3;

  function slugify(text, used) {
    var base = text.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 60) || 'section';
    var slug = base, n = 2;
    while (used[slug]) { slug = base + '-' + n; n++; }
    used[slug] = true;
    return slug;
  }

  function build(nav) {
    var scope = nav.closest('.page-body') || document;
    var content = scope.querySelector('[data-page-content]');
    var list = nav.querySelector('[data-page-toc-list]');
    if (!content || !list) return;

    var headings = content.querySelectorAll(nav.getAttribute('data-toc-headings') || 'h2');
    if (headings.length < MIN_HEADINGS) return;

    var used = {};
    var items = [];

    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent.replace(/\s*#\s*$/, ''), used);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.replace(/\s*#\s*$/, '');
      li.appendChild(a);
      list.appendChild(li);
      items.push({ heading: h, link: a });
    });

    nav.hidden = false;

    // Mark the section currently in view.
    if (!('IntersectionObserver' in window)) return;
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (current) current.removeAttribute('aria-current');
        var match = items.find(function (i) { return i.heading === entry.target; });
        if (match) { match.link.setAttribute('aria-current', 'true'); current = match.link; }
      });
    }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });

    items.forEach(function (i) { io.observe(i.heading); });
  }

  function init() {
    document.querySelectorAll('[data-page-toc]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-render
  document.addEventListener('shopify:section:load', init);
})();
